var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagChina(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3125 3.75H4.6875C2.61643 3.75 0.9375 5.42893 0.9375 7.5V22.5C0.9375 24.5711 2.61643 26.25 4.6875 26.25H25.3125C27.3836 26.25 29.0625 24.5711 29.0625 22.5V7.5C29.0625 5.42893 27.3836 3.75 25.3125 3.75Z",
    fill: "#DB362F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.3125 3.75H4.6875C2.61656 3.75 0.9375 5.42906 0.9375 7.5V22.5C0.9375 24.5709 2.61656 26.25 4.6875 26.25H25.3125C27.3834 26.25 29.0625 24.5709 29.0625 22.5V7.5C29.0625 5.42906 27.3834 3.75 25.3125 3.75ZM28.125 22.5C28.125 24.0506 26.8631 25.3125 25.3125 25.3125H4.6875C3.13687 25.3125 1.875 24.0506 1.875 22.5V7.5C1.875 5.94937 3.13687 4.6875 4.6875 4.6875H25.3125C26.8631 4.6875 28.125 5.94937 28.125 7.5V22.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46098 9.51891L6.74098 7.30078L6.02004 9.51891H3.68848L5.57473 10.8895L4.85379 13.1067L6.74098 11.7361L8.62723 13.1067L7.90629 10.8895L9.79348 9.51891H7.46098Z",
    fill: "#FFFF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9294 7.67672L12.3297 8.34328L12.3972 7.56891L13.1547 7.39453L12.4394 7.09078L12.5078 6.31641L11.9978 6.90234L11.2825 6.59859L11.6819 7.26516L11.1719 7.85109L11.9294 7.67672Z",
    fill: "#FFFF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9359 9.72547L14.0455 10.4952L14.4093 9.80797L15.1752 9.94109L14.6343 9.38328L14.9971 8.69609L14.2996 9.03828L13.7577 8.48047L13.8684 9.25016L13.1699 9.59234L13.9359 9.72547Z",
    fill: "#FFFF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6224 12.7594L15.2346 12.2803L14.4574 12.3075L14.1912 11.5781L13.9774 12.3253L13.2012 12.3534L13.8462 12.7875L13.6324 13.5347L14.2446 13.0556L14.8887 13.4897L14.6224 12.7594Z",
    fill: "#FFFF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4309 14.5653L12.4666 13.7891L11.9809 14.3956L11.2544 14.1219L11.6809 14.7706L11.1953 15.3781L11.9453 15.1719L12.3728 15.8216L12.4084 15.0453L13.1584 14.8391L12.4309 14.5653Z",
    fill: "#FFFF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.3125 4.6875H4.6875C3.13406 4.6875 1.875 5.94656 1.875 7.5V8.4375C1.875 6.88406 3.13406 5.625 4.6875 5.625H25.3125C26.8659 5.625 28.125 6.88406 28.125 8.4375V7.5C28.125 5.94656 26.8659 4.6875 25.3125 4.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagChina);
export default __webpack_public_path__ + "static/media/flag_china.0b6c879de5006ec4d6cdb3c482c4b7d5.svg";
export { ForwardRef as ReactComponent };